module.exports = __webpack_public_path__ + "img/beian.a4497e07.png";